import { render, staticRenderFns } from "./CompetenciesCrud.vue?vue&type=template&id=1fe52d7b&scoped=true"
import script from "./CompetenciesCrud.vue?vue&type=script&lang=js"
export * from "./CompetenciesCrud.vue?vue&type=script&lang=js"
import style0 from "./CompetenciesCrud.vue?vue&type=style&index=0&id=1fe52d7b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fe52d7b",
  null
  
)

export default component.exports